import React from 'react';
import Button from '../../../../components/button/button';
import Modal from '../../../../components/modal';
import { Desktop, Mobile } from '../../../../app-responsive';
import { customStylesDesktop, customStylesMobile } from '../../../../components/business-case-delete-modal/modal-styles-config';
import PopupHeader from '../../../ssm-homepage/ssm-components/popup-header/popup-header';
import SSMCheckBox from '../../../ssm-homepage/ssm-components/ssm-checkbox/ssm-checkbox';
import { FFWD_RADIO_BUTTON_CONFIRM_ID } from '../../../../app-constants';

const ConfirmSiteModal = (props) => {
  const {
    authorableContent: {
      submitButtonText,
      title,
      checkBoxText,
      description,
    },
    reviewTermsAndConditions,
    modalIsOpen,
    onCloseDialogBox,
    onChangedSubmitCheckBox,
    handleSubmit,
    submitLoader,
  } = props;
  const desktopModalStyles = { content: { ...customStylesDesktop.content, width: '50%' } };

  const modalContent = customStyles => (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={onCloseDialogBox}
      style={customStyles}
      ariaHideApp={false}
    >
      <div className="confirm-site-modal">
        <PopupHeader PopTitle={title} />
        <SSMCheckBox
          checkBoxId={FFWD_RADIO_BUTTON_CONFIRM_ID}
          checkBoxLabel={checkBoxText}
          checkBoxDesc={description}
          checkBoxChecked={reviewTermsAndConditions}
          onCheckBoxStatusChanged={onChangedSubmitCheckBox}
        />
        <div className="row">
          <div className="col-12 text-right button-section">
            <Button
              className={`button do-business ${submitLoader ? 'loading' : ''}`}
              buttonText={submitButtonText}
              disabled={!reviewTermsAndConditions}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    </Modal>
  );

  return (
    <React.Fragment>
      <Mobile>
        {modalContent(customStylesMobile)}
      </Mobile>
      <Desktop>
        {modalContent(desktopModalStyles)}
      </Desktop>
    </React.Fragment>
  );
};

export default ConfirmSiteModal;
